/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SearchPlayerMobile200ResponseResults
 */
export interface SearchPlayerMobile200ResponseResults {
    /**
     * 
     * @type {boolean}
     * @memberof SearchPlayerMobile200ResponseResults
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerMobile200ResponseResults
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerMobile200ResponseResults
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerMobile200ResponseResults
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayerMobile200ResponseResults
     */
    mobile?: string;
}


/**
 * Check if a given object implements the SearchPlayerMobile200ResponseResults interface.
 */
export function instanceOfSearchPlayerMobile200ResponseResults(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayerMobile200ResponseResultsFromJSON(json: any): SearchPlayerMobile200ResponseResults {
    return SearchPlayerMobile200ResponseResultsFromJSONTyped(json, false);
}

export function SearchPlayerMobile200ResponseResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayerMobile200ResponseResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'active': !exists(json, 'active') ? undefined : json['active'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
    };
}

export function SearchPlayerMobile200ResponseResultsToJSON(value?: SearchPlayerMobile200ResponseResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'active': value.active,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'number': value.number,
        'mobile': value.mobile,
    };
}

